/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_A21Inputs */

const en_job_form_enum_a21 = /** @type {(inputs: Job_Form_Enum_A21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A2 - Elementary`)
};

const de_job_form_enum_a21 = /** @type {(inputs: Job_Form_Enum_A21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A2 - Grundlegende Kenntnisse`)
};

/**
* | output |
* | --- |
* | "A2 - Elementary" |
*
* @param {Job_Form_Enum_A21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_a21 = /** @type {((inputs?: Job_Form_Enum_A21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_A21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_a21(inputs)
	return en_job_form_enum_a21(inputs)
});
export { job_form_enum_a21 as "job_form_enum_A2" }